<template>
    <v-row style="height: 100%">
      <v-col></v-col>
      <v-col style="width: 350px;height: 100%">
        <transition name="slide-fade">
  <v-card class="entity-overlay" v-if="showEntity">
    <v-card-text style="padding-bottom: 4px">
      <v-row>
        <v-col>
          <div>{{definition.name}}</div>
        </v-col>
        <v-col v-if="!inSelectMode && disabled && !createTask && editEnity.id !== 'new'">
          <v-icon color="success"
                  style="float: right; margin-top: -6px; margin-right: -4px"
                  v-text="'mdi-calendar-plus'"
                  @click="$emit('start-create'); selectPosition = true; createTask = true;"></v-icon>
        </v-col>
      </v-row>
      <p class="text-h6 text--primary truncate-text" v-if="disabled || definition.category === 'AUGR'">
        {{editEnity.name}}
      </p>
      <v-text-field
          v-else
          v-model="editEnity.name"
          :rules="[v => !!v || 'Name ist ein Pflichtfeld.']"
          hint="Der Name des Katastereintrags."
          persistent-hint
          label="Name"
          ref="name"
      ></v-text-field>
      <v-textarea
          label="Beschreibung"
          v-model="editEnity.description"
          rows="3"
          :disabled="disabled"
      ></v-textarea>
      <div>Dateien</div>
      <div>
      <v-carousel v-if="files && files.length > 0"
                  hide-delimiter-background
                  hide-delimiters
                  height="300"
                  :show-arrows="files.length > 1"
      >
        <v-carousel-item
            v-for="(item,i) in files"
            :key="i"
        >
          <v-img
              v-if="isImage(item)"
              style="height: 100%"
              contain
              class="clickable-zoom"
              @click="openFile(item)"
          :src="Server_URL + '/auftragsbuch/cadastre_entry/file/' + editEnity.id + '?file_name=' + encodeURIComponent(item)"
          ></v-img>
          <div v-else class="d-flex flex-column justify-center align-center fill-height clickable-zoom" @click="openFile(item)">
            <v-icon size="75">{{ getFileIcon(item) }}</v-icon>
            <span class="mt-2 text-truncate" style="max-width: 250px;">{{ item }}</span>
          </div>
        </v-carousel-item>
      </v-carousel>
      <v-list dense v-if="newFile">
        <v-list-item
          v-if="newFile"
        >
          <v-list-item-icon>
            <v-icon color="primary" v-text="'mdi-loading'" class="spinner"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="newFile.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list-item
          v-if="disabled && files.length === 0"
      >
        <v-list-item-icon>
          <v-icon v-text="'mdi-attachment-off'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="'Keine Dateien vorhanden'"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
          v-if="!disabled && !newFile"
          @click="fileInputClicked"
      >
        <v-list-item-icon>
          <v-file-input
              style="padding-top: 0px; margin-top: 0px"
              prepend-icon="mdi-attachment-plus"
              hide-input
              truncate-length="15"
              ref="fileInput"
              v-model="newFile"
              @change="addAttachment"
          ></v-file-input>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="'Datei hochladen'"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </div>
    </v-card-text>
    <v-card-actions style="padding-top: 0px">
      <v-subheader style="height: 36px; padding-left: 8px">
        Zusatzinformationen
      </v-subheader>
      <v-spacer></v-spacer>
      <v-btn
          icon
          @click="show = !show"
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider style="margin-top: 0; margin-bottom: 0"></v-divider>
        <v-card-text>
          <v-list dense>
            <div v-for="(field, index) in orderedProperties" :key="field.key">
              <v-list-item style="margin-bottom: 6px">
                <v-combobox v-if="field.property_type === 'auto_complete'"
                            persistent-hint
                            :items="field.auto_complete_options || []"
                            :label="field.name"
                            :hint="field.description"
                            v-model="editEnity.properties[field.key]"
                            :disabled="disabled"
                ></v-combobox>
                <v-text-field v-else-if="field.property_type === 'string' || field.property_type === 'integer' || field.property_type === 'float'"
                              :label="field.name"
                              :hint="field.description"
                              persistent-hint
                              v-model="editEnity.properties[field.key]"
                              :disabled="disabled"
                              :rules="field.property_type === 'float' ? floatRules : (field.property_type === 'integer' ? integerRules : [])"
                ></v-text-field>
                <v-menu
                    v-else-if="field.property_type === 'date'"
                    :ref="field.key + 'date'"
                    v-model="field.show"
                    :close-on-content-click="false"
                    :return-value.sync="editEnity.properties[field.key]"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formatDate(editEnity.properties[field.key])"
                        :label="field.name"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :hint="field.description"
                        :disabled="disabled"
                        persistent-hint
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="editEnity.properties[field.key]"
                      no-title
                      scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="field.show = false"
                    >
                      Abbrechen
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs[field.key + 'date'][0].save(editEnity.properties[field.key])"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <v-checkbox
                    v-else-if="field.property_type === 'boolean'"
                    :label="field.name"
                    color="primary"
                    :hint="field.description"
                    v-model="editEnity.properties[field.key]"
                    persistent-hint
                    :disabled="disabled"
                ></v-checkbox>
                <v-select
                    v-else-if="field.property_type === 'select'"
                    :hint="field.description"
                    persistent-hint
                    :items="field.auto_complete_options || []"
                    :label="field.name"
                    v-model="editEnity.properties[field.key]"
                    :disabled="disabled"
                ></v-select>
                <v-subheader
                    v-else-if="field.property_type === 'sub_header'"
                    style="font-size: 1rem; padding-left: 0px"
                >
                  {{
                    field.name
                  }}
                </v-subheader>
                <v-divider
                    v-if="field.property_type === 'sub_header'"
                ></v-divider>
              </v-list-item>
            </div>
          </v-list>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
        </transition>
        <transition name="slide-fade">
        <v-row style="flex-direction: row-reverse;" v-if="entity.id !== ''">
      <v-btn
          v-if="disabled && !inSelectMode && !createTask"
          elevation="2"
          rounded
          small
          color="primary"
          style="z-index: 200; margin-right: 24px; margin-top: 8px"
          class="text-none"
          @click="disabled = !disabled; $emit('edit', editEnity.id)"
      >Anpassen</v-btn>
          <v-btn
              v-if="disabled && !inSelectMode && !createTask"
              elevation="2"
              rounded
              small
              color="success"
              style="z-index: 200; margin-right: 24px; margin-top: 8px"
              class="text-none"
              @click="emitAddEntry"
          >Eintrag hinzufügen</v-btn>

          <v-btn
              v-if="(inSelectMode || createTask) && !selectPosition"
              elevation="2"
              rounded
              small
              color="success darken-1"
              style="z-index: 200; margin-right: 24px; margin-top: 8px"
              class="text-none"
              @click="selectPosition = true; $emit('start-position-select')"
          >Auftragsort markieren</v-btn>
          <v-btn
              v-if="inSelectMode && selectPosition"
              elevation="2"
              rounded
              small
              color="warning darken-1"
              style="z-index: 200; margin-right: 24px; margin-top: 8px"
              class="text-none"
              @click="selectPosition = false; $emit('end-position-select')"
          >Markieren beenden</v-btn>
          <v-btn
              v-if="createTask && selectPosition"
              elevation="2"
              rounded
              small
              color="success darken-1"
              style="z-index: 200; margin-right: 24px; margin-top: 8px"
              class="text-none"
              @click="$emit('create-task')"
          >Aufgabe erstellen</v-btn>

      <v-btn
          v-if="!disabled && !inSelectMode"
          elevation="2"
          rounded
          small
          color="success"
          style="z-index: 200; margin-right: 24px; margin-top: 8px"
          class="text-none"
          @click="onSave"
      >{{editEnity.id === 'new' ? 'Anlegen' : 'Speichern'}}</v-btn>
      <v-btn
          v-if="!disabled && !inSelectMode"
          elevation="2"
          rounded
          small
          color="primary"
          style="z-index: 200; margin-right: 12px; margin-top: 8px"
          class="text-none"
          @click="cancelEdit"
      >Abbrechen</v-btn>
          <v-btn
              v-if="!disabled && editEnity.id !== 'new' && definition.category !== 'AUGR' && !inSelectMode"
              elevation="2"
              rounded
              small
              color="warning darken-1"
              style="z-index: 200; margin-right: 12px; margin-top: 8px"
              class="text-none"
              @click="showDelete = true;"
          >Löschen</v-btn>
    </v-row>
        </transition>
      </v-col>
      <v-dialog v-model="dialogVisible" fullscreen>
        <v-card :color="'rgba(80,80,80,0.77)'" flat>
          <v-toolbar dark color="transparent" flat>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogVisible = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-carousel
              v-model="dialogCarouselModel"
              height="calc(100% - 64px)"
              hide-delimiter-background
              hide-delimiters
          >
            <v-carousel-item
                v-for="(image, i) in imageFiles"
                :key="i"
            >
              <div class="d-flex justify-center align-center fill-height">
                <v-img
                    :src="Server_URL + '/auftragsbuch/cadastre_entry/file/' + editEnity.id + '?file_name=' + encodeURIComponent(image)"
                    contain
                    height="90vh"
                    width="90vw"
                ></v-img>
              </div>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDelete"
                max-width="420">
        <v-card>
          <v-card-title class="text-h5">
            Eintrag löschen
          </v-card-title>
          <v-card-text>
            Sie sind dabei, den Eintrag <b>"{{editEnity.name}}"</b> zu löschen. Dies kann nicht rückgängig gemacht werden!<br>
            Sind Sie sicher, dass Sie den Eintrag löschen möchten?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="showDelete = false;"
            >
              Abbrechen
            </v-btn>

            <v-btn
                color="error darken-1"
                text
                @click="showDelete = false; disabled = true; $emit('delete', editEnity.id)"
            >
              Trozdem löschen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>

<script>
import {Server_URL} from "@/shared/utils";

export default {
  name: "CadastreEntity",
  computed: {
    Server_URL() {
      return Server_URL
    },
    imageFiles() {
      if (!this.files) return [];
      return this.files.filter(file => this.isImage(file));
    }
  },
  props: {
    entity: {
      type: Object,
      default: () => {
        return {
          id: '',
          aufisn: '',
          definition_id: '',
          definition_name: '',
          name: '',
          description: '',
          properties: {},
        }
      }
    },
    definition: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          category: '',
          description: '',
          properties: [],
          properties_order: [],
        }
      }
    },
    topDefinition: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          category: '',
        }
      }
    },
    inSelectMode: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loader: undefined,
      files: [],
      disabled: true,
      showEntity: false,
      show: false,
      newFile: null,
      editEnity: {
        id: '',
        aufisn: '',
        definition_id: '',
        definition_name: '',
        name: '',
        description: '',
        properties: {},
      },
      orderedProperties: [],
      floatRules: [
        v => {
          if (!v) return true;
          const cleanedValue = v.replace(/\./g, '').replace(',', '.'); // Remove thousands separator, replace comma with dot
          if (isNaN(parseFloat(cleanedValue)) || !isFinite(cleanedValue)) {
            return 'Muss eine gültige Dezimalzahl sein (z.B. 123,45, 1.234,56)';
          }
          return true;
        },
      ],
      integerRules: [
        v => {
          if (!v) return true;
          const cleanedValue = v.replace(/\./g, ''); // Remove thousands separator
          if (!/^-?\d+$/.test(cleanedValue)) { // Regex to check for optional minus and only digits
            return 'Muss eine ganzzahlige Zahl sein (z.B. 123, 1.234)';
          }
          return true;
        },
      ],
      dialogVisible: false,
      dialogCarouselModel: 0,
      showDelete: false,
      selectPosition: false,
      createTask: false,
    }
  },
  watch: {
    entity: {
      handler(newValue) {
        this.$nextTick(() => {
          this.selectPosition = false;
          this.createTask = false;
        if (newValue && newValue.id) {
          this.showDialog();
          this.disabled = true;
          this.files = [];
          this.newFile = null;
        } else {
          this.showEntity = false;
          this.disabled = true;
          this.files = [];
          this.newFile = null;
          this.editEnity = {
            id: '',
            aufisn: '',
            definition_id: '',
            definition_name: '',
            name: '',
            description: '',
            properties: {},
          };
        }
        });
      },
      immediate: true,
    },
  },
  methods: {
    setEditMode() {
      this.disabled = false;
      this.$emit('edit', this.editEnity.id);
      // focus on name field
      this.$nextTick(() => {
        if (this.$refs.name) {
          this.$refs.name.focus();
        }
      });
    },
    isImage(filename) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.svg'];
      return imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
    },
    getFileIcon(filename) {
      const extension = filename.split('.').pop().toLowerCase();
      switch (extension) {
        case 'pdf':
          return 'mdi-file-pdf-box';
        case 'doc':
        case 'docx':
          return 'mdi-microsoft-word';
        case 'xls':
        case 'xlsx':
          return 'mdi-microsoft-excel';
        case 'ppt':
        case 'pptx':
          return 'mdi-microsoft-powerpoint';
        case 'zip':
        case 'rar':
          return 'mdi-folder-zip-outline';
        case 'txt':
          return 'mdi-file-document-outline';
        case 'mp4':
        case 'avi':
        case 'mov':
          return 'mdi-file-video-outline';
        default:
          return 'mdi-file-outline';
      }
    },
    fileInputClicked() {
      this.$refs.fileInput.focus()
      this.$refs.fileInput.$el.querySelector('input[type="file"]').click();
    },
    showDialog() {
      this.orderedProperties = new Array(this.definition.properties_order.length);
      this.setEntity();
      this.showEntity = true;
      // check for files
      if (this.editEnity.id !== 'new') {
        this.$http.get(Server_URL + '/auftragsbuch/cadastre_entry/files/' + this.editEnity.id).then((resp) => {
          if (resp.status === 200) {
            this.files.push(...resp.body.files);
            // sort files alphabetically
            this.files.sort((a, b) => a.localeCompare(b));
          } else {
            this.$emit('error', 'error', 'Fehler beim Abrufen der Dateien');
          }
        }, (resp) => {
          this.$emit('error', 'error', 'Fehler beim Abrufen der Dateien');
        });
      }
    },
    setEntity() {
      let entity = JSON.parse(JSON.stringify(this.entity));
      if (!entity.properties) {
        entity.properties = {};
      }
      for (let i = 0; i < this.definition.properties_order.length; i++) {
        let key = this.definition.properties_order[i];
        let property = this.definition.properties.find(p => p.key === key);
        if (property) {
          property.show = false;
          this.orderedProperties[i] = property;
          if (!entity.properties[key]) {
            entity.properties[key] = '';
            if (property.property_type === 'boolean') {
              entity.properties[key] = false;
            } else if (property.property_type === 'integer') {
              entity.properties[key] = '0';
            } else if (property.property_type === 'float') {
              entity.properties[key] = '0,00';
            }
          } else if (property.property_type === 'integer') {
            // ensure integer is parsed correctly
            entity.properties[key] = entity.properties[key].toString().replace(/\./g, '');
          } else if (property.property_type === 'float') {
            // ensure float is parsed correctly
            entity.properties[key] = entity.properties[key].toString().replace(/\./g, ',');
          }
        }
      }
      this.editEnity = entity;
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
    addAttachment(){
      if (!this.newFile) {
        return;
      }
      const maxFileSize = 25 * 1024 * 1024; // 25 MB
      if (this.newFile && this.newFile.size > maxFileSize) {
        this.$emit('error', 'error', 'Die Datei ist zu groß. Maximal 25 MB erlaubt.');
        this.newFile = null;
        return;
      }
      let formData = new FormData();
      formData.append('upload_file', this.newFile);
      this.$http.post(Server_URL + '/auftragsbuch/cadastre_entry/file/' + this.editEnity.id,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then((resp) => {
        if (resp.status === 200 || resp.status === 201) {
          this.$emit('error', 'success', 'Datei erfolgreich hochgeladen: ' + this.newFile.name);
          this.files.push(this.newFile.name);
          // sort files alphabetically
          this.files.sort((a, b) => a.localeCompare(b));
          this.newFile = null;
        } else {
          this.$emit('error', 'error', 'Fehler beim Hochladen der Datei: ' + this.newFile.name);
          this.newFile = null;
        }
      }, (resp) => {
        this.$emit('error', 'error', 'Fehler beim Hochladen der Datei: ' + this.newFile.name);
        this.newFile = null;
      });
    },
    deleteAttachment() {

    },
    cancelEdit() {
      this.setEntity();
      this.disabled = true;
      this.$emit('cancel', this.editEnity.id);
    },
    onSave() {
      if (this.definition.category !== 'AUGR') {
        // check if name is set
        if (!this.editEnity.name || this.editEnity.name.trim() === '') {
          // set error state
          this.$emit('error', 'error', 'Der Name muss gesetzt sein.');
          return;
        }
      }
      for (let i = 0; i < this.orderedProperties.length; i++) {
        if (this.orderedProperties[i].property_type === 'integer') {
          let value = this.editEnity.properties[this.orderedProperties[i].key].replace(/\./g, '');
          if (!/^-?\d+$/.test(value)) {
            this.$emit('error', 'error',
              `Das Feld "${this.orderedProperties[i].name}" muss eine gültige ganze Zahl sein (z.B. 123, 1.234).`);
            return;
          }
        } else if (this.orderedProperties[i].property_type === 'float') {
          let value = this.editEnity.properties[this.orderedProperties[i].key].replace(/\./g, '').replace(',', '.');
          if (isNaN(parseFloat(value)) || !isFinite(value)) {
            this.$emit('error', 'error',
              `Das Feld "${this.orderedProperties[i].name}" muss eine gültige Dezimalzahl sein (z.B. 123,45, 1.234,56).`);
            return;
          }
        }
      }
      let reqEntity = JSON.parse(JSON.stringify(this.editEnity));
      // all good, parse the fields in the correct datatypes
      for (let i = 0; i < this.orderedProperties.length; i++) {
        if (this.orderedProperties[i].property_type === 'integer') {
          let value = reqEntity.properties[this.orderedProperties[i].key].replace(/\./g, '');
          reqEntity.properties[this.orderedProperties[i].key] = parseInt(value, 10);
        } else if (this.orderedProperties[i].property_type === 'float') {
          let value = reqEntity.properties[this.orderedProperties[i].key].replace(/\./g, '').replace(',', '.');
          reqEntity.properties[this.orderedProperties[i].key] = parseFloat(value);
        }
      }
      this.$emit('save', reqEntity)
    },
    emitAddEntry() {
      this.$emit('add-entity', this.editEnity.aufisn, this.definition.category === 'AUGR' ? (this.topDefinition.category !== 'AUGR' ? this.topDefinition.id : undefined ) : this.definition.id)
    },
    openFile(fileName) {
      let url = Server_URL + '/auftragsbuch/cadastre_entry/file/' + this.editEnity.id + '?file_name=' + encodeURIComponent(fileName);
      if (this.isImage(fileName)) {
        const imageIndex = this.imageFiles.findIndex(img => img === fileName);
        if (imageIndex !== -1) {
          this.dialogCarouselModel = imageIndex;
          this.dialogVisible = true;
        }
      } else if  (navigator.userAgent.startsWith("Windows - BisOffice")) {
        this.$http.get(url, {responseType: 'blob'}).then(response => {
          return response.blob();
        }).then(blob => {
          try {
            windowsFileService.onFile(
                blob.toBase64(),
                fileName,
                blob.type,
            ).then(r => {
              if (r && !r.Success) {
                console.log(r)
              }
            }).catch(e => {
              console.log(e)
            });
          } catch (e) {
            console.log(e);
          }
        });
      } else {
        window.open(Server_URL + '/auftragsbuch/cadastre_entry/file/' + this.editEnity.id + "?file_name=" + encodeURIComponent(fileName), '_blank');
      }
    }
  }

}
</script>

<style scoped>

.entity-overlay {
  margin-top: 50px;
  width: 350px;
  margin-right: 10px;
  max-height: calc(100% - 180px);
  margin-left: auto;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 200;
}

.truncate-text {
  display: -webkit-box; /* Required for the next two properties to work */
  -webkit-line-clamp: 2; /* Limits the text to two lines */
  -webkit-box-orient: vertical; /* Orients the box vertically */
  overflow: hidden; /* Hides any overflowing content */
  text-overflow: ellipsis; /* Adds the ellipsis (...) for overflowing text */
}

.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

::v-deep .v-list-item__icon {
  margin-right: 8px;
  margin-top: 6px;
  margin-bottom: 6px;
}

::v-deep .v-list-item__content {
  padding: 0;
}

::v-deep .v-list-item {
  min-height: 24px;
}

::v-deep .v-input--selection-controls.v-input {
  flex: 1 1 auto;
}

::v-deep .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  margin-top: 2px;
  margin-bottom: 0;
}

.spinner {
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

::v-deep .v-carousel__controls__item {
  color: #5d5e6d !important;
}

.clickable-zoom {
  transition: transform 0.2s ease-in-out;
}

.clickable-zoom:hover {
  transform: scale(1.2);
  cursor: pointer;
}

</style>
